import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup, FormGroupName, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { map, Observable, of, startWith } from 'rxjs';
import { HeaderConfigFormControls } from '../../../pages/form-app/models/app-form';
import { ColorPickerComponent } from '../color-picker/color-picker.component';

@Component({
    selector: 'app-header-customization',
    imports: [CommonModule, ReactiveFormsModule, ColorPickerComponent, MatSlideToggleModule],
    templateUrl: './header-customization.component.html',
    styleUrl: './header-customization.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupName }]
})
export class HeaderCustomizationComponent implements OnInit {
    public isGradientEnabled$: Observable<boolean>;
    public headerPreviewBackground$: Observable<string>;
    public headerTextActiveColor$: Observable<boolean>;

    constructor(private formGroupName: FormGroupName) {}

    get form(): FormGroup<HeaderConfigFormControls> {
        return this.formGroupName?.control as FormGroup<HeaderConfigFormControls>;
    }

    get isGradientEnabledCtrl(): AbstractControl<boolean | null> | null {
        return this.form?.get('isGradientEnabled');
    }

    get headerTextActiveColorCtrl(): AbstractControl<boolean | null | undefined> | null {
        return this.form?.get('headerTextActiveColor');
    }

    ngOnInit(): void {
        if (!this.form) {
            return;
        }

        this.setupIsGradientEnabledObservable();
        this.setupHeaderTextActiveColorObservable();
        this.setupHeaderPreviewBackgroundObservable();
    }

    private setupIsGradientEnabledObservable(): void {
        this.isGradientEnabled$ =
            this.isGradientEnabledCtrl?.valueChanges.pipe(
                startWith(this.isGradientEnabledCtrl.value),
                map((v) => !!v)
            ) ?? of(false);
    }

    private setupHeaderTextActiveColorObservable(): void {
        this.headerTextActiveColor$ =
            this.headerTextActiveColorCtrl?.valueChanges.pipe(
                startWith(this.headerTextActiveColorCtrl.value),
                map((v) => !!v)
            ) ?? of(false);
    }

    private setupHeaderPreviewBackgroundObservable(): void {
        this.headerPreviewBackground$ = this.form.valueChanges.pipe(
            startWith(this.form.value),
            map(() => {
                const currentValue = this.form.value;
                const base = currentValue?.headerBackgroundColor || '#ffffff';
                const enabled = !!currentValue?.isGradientEnabled;

                if (!enabled) {
                    return base;
                }

                const c0 = base;
                const c30 = currentValue?.headerBackgroundColor30 || c0;
                const c62 = currentValue?.headerBackgroundColor62 || c0;
                const c100 = currentValue?.headerBackgroundColor100 || c0;
                return `linear-gradient(90deg, ${c0} 0%, ${c30} 30%, ${c62} 62.5%, ${c100} 100%)`;
            })
        );
    }
}
